import { defineComponent as _defineComponent } from 'vue'
import V3Icon from "@/components/v3-icons/V3Icon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'V3SideBarItemNew',
  props: {
    icon: null,
    text: null,
    active: { type: Boolean },
    small: { type: Boolean },
    isIconBranches: { type: Boolean },
    isExpandable: { type: Boolean },
    showMinimized: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,V3Icon }
}

})